import { Box, Button, Typography, alpha, styled } from '@mui/material';
import { UnfoldMore } from '@mui/icons-material';
import { PageLinks } from '@gc-bridge/components/Footer/PageLinks';
import { AdditionalColors } from '@gc-bridge/theme/colors';
import { RouterLink } from '@gc-bridge/components/RouterLink';

const Container = styled(Box)(() => ({
  backgroundColor: AdditionalColors.Honeydew,
  display: 'flex',
  alignItems: 'center',
  height: '20px'
}));

const StyledTypography = styled(Typography)(() => ({
  paddingLeft: '20px',
  color: alpha(AdditionalColors.Black, 0.47),
  width: '236px',
  boxSizing: 'border-box',
  fontSize: '10px',
}));

const StyledLinkBox = styled(Box)(() => ({
  width: '600px',
  display: 'flex',
  justifyContent: 'space-around',
}));

const StyledLink = styled(RouterLink)(() => ({
  color: alpha(AdditionalColors.Black, 0.47),
  fontSize: '10px',
  fontFamily: 'Arial',
}));

const StyledButton = styled(Button)(() => ({
  color: alpha(AdditionalColors.Black, 0.47),
  fontSize: '10px',
  fontWeight: 400,
  textTransform: 'none',
  textDecoration: 'underline',
  letterSpacing: 'normal',
  padding: 0,
  lineHeight: 0,

  '&:hover': {
    backgroundColor: 'inherit',
    textDecoration: 'underline',
  },
}));

const StyledUnfoldMore = styled(UnfoldMore)(() => ({
  color: alpha(AdditionalColors.Black, 0.47),
  transform: 'rotate(45deg)',
  position: 'absolute',
  top: 0,
  right: '5px',
  height: '20px',
}));

interface Props {
  onExpand: () => void;
}

export const CompressedFooter = ({ onExpand }: Props) => {
  const currentYear = new Date().getFullYear();
  return (
    <Container>
      <StyledTypography>© {currentYear} Guy Carpenter</StyledTypography>
      <PageLinks
        StyledLinkBox={StyledLinkBox}
        StyledLink={StyledLink}
        StyledButton={StyledButton}
      />
      <StyledUnfoldMore onClick={onExpand} />
    </Container>
  );
};
